// import React from 'react';
// import { Navigate } from 'react-router-dom';
// import { useAuth } from './AuthContext';

// const ProtectedRoute = ({ children, adminOnly }) => {
//   const { user } = useAuth();

//   if (!user) return <Navigate to="/login" />;

//   const adminEmail = "glumistcare@gmail.com";
//   if (adminOnly && user.email !== adminEmail) return <Navigate to="/" />;

//   return children;
// };

// export default ProtectedRoute;
import React, { useEffect } from 'react';
import { useAuth } from './AuthContext';
import { useLoginModal } from '../context/LoginModalWrapper';

const ProtectedRoute = ({ children, adminOnly }) => {
  const { user } = useAuth();
  const { openLoginModal } = useLoginModal();

  useEffect(() => {
    if (!user) {
      openLoginModal(); // Open the modal if user not logged in
    }
  }, [user, openLoginModal]);

  const adminEmail = "groomberry179@gmail.com";

  if (!user) return null; // Don't render children while waiting for login

  if (adminOnly && user.email !== adminEmail) {
    return <div className="p-4 text-red-500 font-semibold">Access denied</div>;
  }

  return children;
};

export default ProtectedRoute;
